module.exports = __webpack_public_path__ + "img/headBg1.64ef724c.png";